import type { FaireProductEntity } from "../../entity_types/product";

export const p_ao488ng21p: FaireProductEntity = {
  token: "p_ao488ng21p",
  type: "product",
  name: "Gedeb Bulk Bag (5lb)",
  brandToken: "b_50b0t2xt",
  brandName: "Canyon Coffee",
  imageUrl: "https://cdn.faire.com/fastly/aa26ae5bc68959caf0d80e3e11b3936ba0ff90956532ad482be8bc33524cface.jpeg",
  galleryImageUrls: [],
  priceDollars: 70.4,
  description: "Available year round, from the Gedeb region in Ethiopia. We love coffees from this area for their fragrant, floral aroma, sweet, balanced taste, and smooth lime-like acidity.\n\n𝐀𝐛𝐨𝐮𝐭 𝐆𝐞𝐝𝐞𝐛\n• Origin: Ethiopia\n• Producer: SNAP (Negusse Debela)\n• Region: Gedeb\n• Elevation: 2300 MASL\n• Process: Washed\n• Certification: Organic\n• We Taste: Persimmon, Lime and Bergamot\n\n𝐄𝐱𝐩𝐞𝐫𝐢𝐞𝐧𝐜𝐞\nThe cup is deliciously sweet and round, with a smooth lime-like acidity. The broadest note we picked up on hearkened to fuyu persimmons — Ally's favorite fruit. When ripe, we love persimmons for their developed autumnal sweetness, which is almost honey-like. They seem to carry a trace of cinnamon.",
  tags: [],
  msrpDollars: 140.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:47.339Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
